var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedPopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EA5455"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5612 39.938C42.843 40.2198 43.0013 40.602 43.0013 41.0005C43.0013 41.399 42.843 41.7812 42.5612 42.063C42.2794 42.3448 41.8972 42.5031 41.4987 42.5031C41.1002 42.5031 40.718 42.3448 40.4362 42.063L32.4999 34.1242L24.5612 42.0605C24.2794 42.3423 23.8972 42.5006 23.4987 42.5006C23.1002 42.5006 22.718 42.3423 22.4362 42.0605C22.1544 41.7787 21.9961 41.3965 21.9961 40.998C21.9961 40.5995 22.1544 40.2173 22.4362 39.9355L30.3749 31.9992L22.4387 24.0605C22.1569 23.7787 21.9986 23.3965 21.9986 22.998C21.9986 22.5995 22.1569 22.2173 22.4387 21.9355C22.7205 21.6537 23.1027 21.4954 23.5012 21.4954C23.8997 21.4954 24.2819 21.6537 24.5637 21.9355L32.4999 29.8742L40.4387 21.9342C40.7205 21.6524 41.1027 21.4941 41.5012 21.4941C41.8997 21.4941 42.2819 21.6524 42.5637 21.9342C42.8455 22.216 43.0038 22.5982 43.0038 22.9967C43.0038 23.3953 42.8455 23.7775 42.5637 24.0592L34.6249 31.9992L42.5612 39.938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedPopIcon);
export default __webpack_public_path__ + "static/media/FailedPopIcon.1a02042ba36da2fc466fe2df6e13718f.svg";
export { ForwardRef as ReactComponent };